import { ENVIRONMENT } from 'core/datasets/action';
import { EnvironmentReducerState } from '../types/redux/environmentState';
import { EnvironmentActions } from 'environment/types/redux/environmentActions';
import { AppState } from 'core/redux/rootReducer';

const initState: EnvironmentReducerState = {
    invoiceAsPaymentNotification: false,
    tipsAndTricksEnabled: false,
    emissionsEnabled: false,
    messagingSettings: { isMessagingEnabled: false, displayName: null },
    settingsLoaded: false,
    agreementExtensionButtonEnabled: false,
    agreementTerminationMinimumPriorToDays: 30,
    agreementTerminationButtonEnabled: false,
    assistantSettings: { enabled: false, provider: null },
    pzuInsuranceEnabled: false,
    showMetersInTenantApp: false,
};

export const environmentReducer = (state = initState, action: EnvironmentActions): EnvironmentReducerState => {
    switch (action.type) {
        case ENVIRONMENT.SET_ENVIRONMENT_SETTINGS: {
            const { data } = action.payload;

            if (!data) return state;

            const {
                invoiceAsPaymentNotification,
                messagingSettings,
                tipsAndTricksEnabled,
                emissionsEnabled,
                agreementExtensionButtonEnabled,
                agreementTerminationMinimumPriorToDays,
                agreementTerminationButtonEnabled,
                assistantSettings,
                pzuInsuranceEnabled,
                showMetersInTenantApp,
            } = data.getEnvironmentSettingsBySaasEnvironment;

            return {
                ...state,
                invoiceAsPaymentNotification,
                tipsAndTricksEnabled,
                emissionsEnabled,
                messagingSettings,
                settingsLoaded: true,
                agreementExtensionButtonEnabled,
                agreementTerminationMinimumPriorToDays,
                agreementTerminationButtonEnabled,
                assistantSettings,
                pzuInsuranceEnabled,
                showMetersInTenantApp,
            };
        }
        default:
            return state;
    }
};

export const tipsAndTricksEnabledSelector: (state: AppState) => boolean = (state) =>
    state.environment.tipsAndTricksEnabled;

export const emissionsEnabledSelector: (state: AppState) => boolean = (state) => state.environment.emissionsEnabled;

export const showMetersInTenantAppSelector: (state: AppState) => boolean = (state) =>
    state.environment.showMetersInTenantApp;

export const settingsLoadedSelector: (state: AppState) => boolean = (state) => state.environment.settingsLoaded;

export const minTerminationDaySelector: (state: AppState) => number = (state) =>
    state.environment.agreementTerminationMinimumPriorToDays;

export const assistantSettingsEnabledSelector: (state: AppState) => boolean = (state) =>
    state.environment.assistantSettings.enabled;

export const assistantSettingsProviderSelector: (state: AppState) => string | null = (state) =>
    state.environment.assistantSettings.provider;

export const pzuInsuranceEnabledSelector: (state: AppState) => boolean = (state) =>
    state.environment.pzuInsuranceEnabled;
